export class Rights {
    NoAdminRights!: boolean;
    OrganisationAdmin!: boolean;
    WhitelabelAdmin!: boolean;
    SystemAdmin!: boolean;
  }